
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptItemsGrid extends Serenity.EntityGrid<JobWorkReceiptItemsRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkReceiptItems'; }
        protected getDialogType() { return JobWorkReceiptItemsDialog; }
        protected getIdProperty() { return JobWorkReceiptItemsRow.idProperty; }
        protected getInsertPermission() { return JobWorkReceiptItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReceiptItemsRow.localTextPrefix; }
        protected getService() { return JobWorkReceiptItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}